import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {BlockTypeEnum, Field, FieldType, FormModel} from '../../../../common/components/form/models';
import {MatSelectChange} from '@angular/material/select';
import {FilterFieldCustomEnabled} from '../../../../common/services/responses/filter-field-custom-enabled.model';
import {ResponsesService} from '../../../../common/services/responses/responses.service';
import {SubSink} from '@Common/core/utils/subsink';

@Component({
  selector: 'app-filter-selection',
  templateUrl: './filter-selection.component.html',
  styleUrls: ['./filter-selection.component.scss']
})
export class FilterSelectionComponent implements OnInit, OnChanges {
  @Input() form: FormModel;
  @Output() onFiltering: EventEmitter<FilterFieldCustomEnabled[]> = new EventEmitter<FilterFieldCustomEnabled[]>();
  fields: Field[] = [];
  fieldsEnabled: FilterFieldCustomEnabled[] = [];
  selectedField: Field;
  selectedValue: FilterFieldCustomEnabled = null;
  subSink = new SubSink();
  selectFieldEvent: MatSelectChange;

  constructor(private responsesService: ResponsesService) { }

  ngOnInit(): void {
    this._listenFilterRaz();
  }
  private _listenFilterRaz() {
    this.subSink.sink = this.responsesService.onFilterCustomRaz$
      .subscribe((_filter: FilterFieldCustomEnabled) => {
        this._dropFilterInEnabled(_filter);
        this.onFiltering.emit(this.fieldsEnabled);
      });
    this.subSink.sink = this.responsesService.onFilterCustomRazAll$.subscribe(_ => {
      this.fieldsEnabled = [];
      this.onFiltering.emit(this.fieldsEnabled);
    });
  }
  private _dropFilterInEnabled(filter) {
    const idx = this.fieldsEnabled.indexOf(filter);
    if (idx !== -1) {
      this.fieldsEnabled.splice(idx, 1);
    }
  }
  onFilterRaz(filter: FilterFieldCustomEnabled) {
    if (filter) {
      this.responsesService.filterCustomRazSubject.next(filter);
    } else {
      this.responsesService.filterCustomRazAllSubject.next(null);
    }
  }

  /**
   * Exclure certains types de champs du filtrage
   * @param {Field} field
   * @private
   */
  private _excludeFields(field: Field) {
    switch (field.options_obj.controlType) {
      case FieldType.TypeTextarea:
      case FieldType.TypeFile:
      case FieldType.TypeLabel:
        return false;
    }
    return true;
  }
  /**
   * Mise à plat des champs paramétrés du formulaire
   * uniquement les champs "demandeur" (est exclu le bloc administratif)
   * @private
   */
  private _fieldsDemandeur() {
    let fields: Field[] = [];
    this.form.blocks
      .filter(_block => _block.type === BlockTypeEnum.Public)
      .forEach(_block =>
        fields = [...fields, ..._block.fields_objs.filter(_field => this._excludeFields(_field)).map(_field => _field)]);
    this.fields = fields;
  }
  onSelectField(item: MatSelectChange) {
    this.selectFieldEvent = item;
    this.selectedField = item.value as Field;
  }
  onValueChanged(option: FilterFieldCustomEnabled) {
    this.selectedValue = option;
  }
  isDisabled() {
    return !this.selectedField || !this.selectedValue;
  }
  onAddFilter() {
    if (this.selectedField && this.selectedValue) {
      this.fieldsEnabled = [...this.fieldsEnabled, ...[this.selectedValue]];
      this.onFiltering.emit(this.fieldsEnabled);
      this.selectedField = null;
      this.selectedValue = null;
      this.selectFieldEvent.source.writeValue(null);
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.form?.currentValue) {
      this._fieldsDemandeur();
    }
  }
}
